import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import ImageLoader from 'react-imageloader';
import CircularProgress from '@material-ui/core/CircularProgress';

import classes from './Gallery.module.scss';
import arrowLong from '../../../assets/images/arrow-long.svg';
import ShowImage from '../../UI/ShowImage/ShowImage';

function importAll(r) {
  return r.keys().map(r);
}
const imagesJane = importAll(require.context('../../../assets/images/Jane in mahabs', false, /\.(png|jpe?g|svg|webp)$/));
const imagesChennai = importAll(require.context('../../../assets/images/People of chennai', false, /\.(png|jpe?g|svg|webp)$/));
const imagesBeauty = importAll(require.context('../../../assets/images/Beauty and the beach', false, /\.(png|jpe?g|svg|webp)$/));
const imagesVinu = importAll(require.context('../../../assets/images/Vinu sha', false, /\.(png|jpe?g|svg|webp)$/));
const imagesGraffiti = importAll(require.context('../../../assets/images/Street graffiti', false, /\.(png|jpe?g|svg|webp)$/));

function sortingFunction(a, b){
  var aArr = a.split('/');
  var aNum = +aArr[aArr.length-1].split('.')[0];
  var bArr = b.split('/');
  var bNum = +bArr[bArr.length-1].split('.')[0];
  if(aNum < bNum) { return -1; }
  if(aNum > bNum) { return 1; }
  return 0;
}
imagesChennai.sort(sortingFunction);
imagesJane.sort(sortingFunction);
imagesBeauty.sort(sortingFunction);
imagesVinu.sort(sortingFunction);
imagesGraffiti.sort(sortingFunction);

const albums = [
  {
    images: imagesChennai,
    title: 'People of Chennai',
    span: {
      '0': { x: 2 },
      '2': { x: 2 },
      '35': { x: 2 },
      '36': { x: 2 },
      '39': { x: 2 },
    }
  },
  {
    images: imagesBeauty,
    title: 'Beauty and the beach',
    span: {
      '1': { x: 2 },
      '6': { x: 1 },
      '7': { x: 1 },
      '8': { x: 1 },
      '9': { x: 2 }
    }
  },
  {
    images: imagesJane,
    title: 'Jane in mahabs',
    span: {
      '1': { x: 2 },
      '3': { y: 2 },
      '2': { x: 2 },
      '4': { x: 2 },
      '5': { x: 3 },
      '6': { x: 3 },
      '7': { x: 2 },
    }
  },
  {
    images: imagesGraffiti,
    title: 'Luzagrat and graffiti',
    span: {
      '3': { x: 3 },
    }
  },
  {
    images: imagesVinu,
    title: 'Vinu sha\'s dream',
    span: {
      '0': { x: 2 },
      '2': { x: 3, y: 2 },
    }
  }
];

const textChangeVarients = {
  from: { x: -100, opacity: 0 },
  to: { x: 0, opacity: 1 },
  exit: { x: 100, opacity: 0 }
}
// const imageChangeVarients = {
//   from: { scale: 0.5, opacity: 0 },
//   to: { scale: 1, opacity: 1, transition: { delay: 0.1 } },
//   exit: { scale: 0.5, opacity: 0 }
// }

const Gallery = ({ activeIndex, setActiveIndex, onBack, className, style }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [showImage, setShowImage] = useState(null);

  useEffect(()=> {
    setSelectedIndex(0);
  }, [activeIndex]);

  const rootClass = [classes.Gallery];
  if (className) rootClass.push(className);
  // console.log('ALBUMS >> ');
  // albums.forEach(i => console.log(i));

  const showImageClicked = ()=> {
    if (albums[activeIndex].images[selectedIndex] && !showImage) {
      setShowImage(albums[activeIndex].images[selectedIndex]);
    }
  }

  const prevIndex = activeIndex > 0 ? activeIndex-1 : albums.length-1;
  const nextIndex = activeIndex < albums.length-1 ? activeIndex+1 : 0;

  return (
    <div className={rootClass.join(' ')} style={style ? style:{}}>
      {/* <div className={classes.BackButton} onClick={onBack}>
        <div className={classes.Arrow}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.16 16.36"
            style={{ transform: `rotate3d(0, 1, 0, -180deg)` }}
          >
            <g id="Layer_2" data-name="Layer 2">
              <g id="Layer_1-2" data-name="Layer 1">
                <polygon points="1.36 16.36 0 14.89 7.22 8.18 0 1.46 1.36 0 10.16 8.18 1.36 16.36"/>
              </g>
            </g>
          </svg>
        </div>

        <p className={classes.Text}>Go back to main page</p>
      </div> */}

      <div className={classes.Contents}>

        <div className={classes.Left}>
          <div className={classes.ShowImage}>
            {/* <div className={classes.ImageContainer}>
              <AnimatePresence exitBeforeEnter>
                <motion.img src={albums[activeIndex].images[selectedIndex]} alt="IMG" className={classes.Image}
                  onClick={showImageClicked}
                  key={selectedIndex + '-' + activeIndex}
                  variants={imageChangeVarients}
                  initial="from"
                  animate="to"
                  exit="exit"
                />
              </AnimatePresence>
            </div> */}
            <ImageLoader
              className={classes.ImageContainer}
              src={albums[activeIndex].images[selectedIndex]}
              // onClick={showImageClicked}
              wrapper={React.createFactory('div')}
              preloader={() => <CircularProgress />}
              imgProps={{
                onClick: showImageClicked,
                className: classes.Image
              }}
            >
              Image load failed!
            </ImageLoader>
          </div>
        </div>

        <div className={classes.Right}>
          <div className={classes.Top}>
            <div className={[classes.ChangeButton, classes.ChangePrev].join(' ')}
                onClick={()=> setActiveIndex(prevIndex)}
            >
              <img src={arrowLong} alt="ARROW" className={classes.Logo} style={{ transform: 'scale(-1)' }} />
              <AnimatePresence exitBeforeEnter>
                <motion.p className={classes.Text}
                  variants={textChangeVarients}
                  key={activeIndex}
                  initial="from"
                  animate="to"
                  exit="exit"
                >{albums[prevIndex].title}</motion.p>
              </AnimatePresence>
            </div>
            <div className={[classes.ChangeButton, classes.ChangeNext].join(' ')} style={{flexDirection: 'row-reverse'}}
                onClick={()=> setActiveIndex(nextIndex)}
            >
              <img src={arrowLong} alt="ARROW" className={classes.Logo} />
              <AnimatePresence exitBeforeEnter>
                <motion.p className={classes.Text}
                  variants={textChangeVarients}
                  key={activeIndex}
                  initial="from"
                  animate="to"
                  exit="exit"
                >{albums[nextIndex].title}</motion.p>
              </AnimatePresence>
            </div>

            <AnimatePresence exitBeforeEnter>
              <motion.h3 className={classes.Title}
                variants={textChangeVarients}
                key={activeIndex}
                initial="from"
                animate="to"
                exit="exit"
                transition={{ duration: 0.2 }}
              >{albums[activeIndex].title}</motion.h3>
            </AnimatePresence>
          </div>

          <div className={[classes.Bottom, 'scrollable', 'scroll-bar'].join(' ')}
            // onMouseEnter={()=> document.body.style = 'overflow: hidden'}
            // onMouseLeave={()=> document.body.style = 'overflow: auto'}
          >
            <div className={classes.Images}>
              {albums[activeIndex].images.map((img, i) => {
                const classNames = [classes.ImageContainer];
                const span = albums[activeIndex].span[''+i];
                if (span && span.x === 2) classNames.push(classes.Span2);
                if (span && span.y === 2) classNames.push(classes.SpanY2);
                if (span && span.x === 3) classNames.push(classes.Span3);
                return (
                  <ImageLoader
                    key={i}
                    className={classNames.join(' ')}
                    src={img}
                    // onClick={()=> setSelectedIndex(i)}
                    wrapper={React.createFactory('div')}
                    preloader={() => <CircularProgress />}
                    imgProps={{
                      onClick: ()=> setSelectedIndex(i),
                      className: classes.Image
                    }}
                  >
                    Image load failed!
                  </ImageLoader>
                );
              })}
            </div>
          </div>
        </div>

      </div>

      {/* <div key={i} className={classNames.join(' ')}
                    onClick={()=> setSelectedIndex(i)}
                  >
                    <motion.img src={img} alt="IMG" className={classes.Image}
                      key={activeIndex}
                      variants={imageChangeVarients}
                      initial="from"
                      animate="to"
                      exit="exit"
                    />
                  </div> */}

      <ShowImage  src={showImage} onClosed={()=> setShowImage(null)} />
    </div>
  );
}

export default Gallery;